var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('router-link',{staticClass:"small text-muted text-decoration-none",attrs:{"to":"/register"}},[_vm._v("¿Aún no eres usuario? Regístrate.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }